import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import * as Input from "../Form/Input";

export type PasswordInputProps = {
  id?: string;
  name?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  autoComplete?: string;
  disabled?: boolean;
  variant?: "default" | "auth";
  className?: string;
};

export function PasswordInput({
  id,
  name,
  value,
  onChange,
  placeholder = "••••••••",
  autoComplete = "current-password",
  disabled,
  variant = "default",
  className,
}: PasswordInputProps) {
  const [visible, setVisible] = useState(false);

  return (
    <Input.Root variant={variant} className={className}>
      <Input.Control
        id={id}
        name={name}
        type={visible ? "text" : "password"}
        autoComplete={autoComplete}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
      <button
        type="button"
        disabled={disabled}
        onClick={() => setVisible((v) => !v)}
        className={
          variant === "auth"
            ? "shrink-0 rounded-lg p-1.5 text-zinc-500 outline-none transition-colors hover:bg-zinc-100 hover:text-zinc-800 focus-visible:ring-2 focus-visible:ring-apcap/35 disabled:opacity-50 dark:hover:bg-zinc-800 dark:hover:text-zinc-200"
            : "shrink-0 rounded-md p-1 text-zinc-500 outline-none transition-colors hover:bg-zinc-100 hover:text-zinc-800 focus-visible:ring-2 focus-visible:ring-violet-500/50 disabled:opacity-50 dark:hover:bg-zinc-700 dark:hover:text-zinc-200 dark:focus-visible:ring-violet-400/50"
        }
        aria-label={visible ? "Ocultar senha" : "Mostrar senha"}
      >
        {visible ? (
          <EyeOff className="h-4 w-4" aria-hidden />
        ) : (
          <Eye className="h-4 w-4" aria-hidden />
        )}
      </button>
    </Input.Root>
  );
}
